import { Role } from "types/generated";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { ButtonIconProps } from "ds/components/ButtonIcon";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";

import { showDeleteConfirmation } from "../DeleteConfirmation";
import { showRoleEditDetailsDrawer } from "../EditDetailsDrawer";

type RoleActionsProps = {
  role: Role;
  analyticsPage: AnalyticsPageOrganization;
  onDeleteSuccess?: () => void;
  refetchQueries: string[];
  size?: ButtonIconProps["size"];
  isSystem?: boolean;
};

const RoleActions = ({
  role,
  analyticsPage,
  onDeleteSuccess,
  size = "small",
  refetchQueries,
}: RoleActionsProps) => {
  const roleUrl = `/settings/role/${role.id}`;

  return (
    <DropdownMenuEllipsis tooltip="Role actions" dotsSize={size}>
      {!role.isSystem && (
        <>
          <DropdownMenuItem
            analyticsPage={analyticsPage}
            analyticsTitle="Edit details clicked"
            onAction={() => showRoleEditDetailsDrawer({ role, analyticsPage, refetchQueries })}
          >
            Edit details
          </DropdownMenuItem>
          <DropdownMenuItem
            analyticsPage={analyticsPage}
            analyticsTitle="Add permissions clicked"
            href={`${roleUrl}/permissions/`}
          >
            Add permissions
          </DropdownMenuItem>
        </>
      )}
      <CopyFieldDropdownMenuItem
        analyticsPage={analyticsPage}
        analyticsTitle="Copy ID clicked"
        title="Copy ID"
        value={role.slug}
      />
      {!role.isSystem && (
        <DropdownMenuItem
          analyticsPage={analyticsPage}
          danger
          analyticsTitle="Delete Role Clicked"
          analyticsProps={{
            roleName: role.name,
          }}
          onAction={() =>
            showDeleteConfirmation({
              id: role.id,
              name: role.name,
              roleBindingsCount: role.roleBindingsCount,
              successCallback: onDeleteSuccess,
            })
          }
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default RoleActions;
